export const PREV_PATH = "prevPath";
